import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
import { PapiUser } from '@wix/da-papi-types';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { pushModal } from '../../Modals/redux/basicActions';
import { verifyLoggedOutAccess } from '../../redux/loggedout/actionCreators';
import { ModalType } from '../../Modals/redux/types';
import type { UserGiftState } from './types';

export const reduxInitialized = createAction(`${reduxKey}.REDUX_INITIALIZED`, () => ({}));

export const initGiftState = createAction(`${reduxKey}.INIT_GIFT_STATE`, (user: PapiUser) => ({
  user,
}));

export const initGiftStateSuccess = createAction(
  `${reduxKey}.INIT_GIFT_STATE_SUCCESS`,
  (user: PapiUser, payload: UserGiftState) => ({ user, ...payload })
);

export const initGiftStateFailure = createAction(
  `${reduxKey}.INIT_GIFT_STATE_FAILURE`,
  (user: PapiUser) => ({ user })
);

export const pushGivePointsModal = verifyLoggedOutAccess(
  ReferralType.GIVE,
  (username: string, title: string) =>
    pushModal(ModalType.GIVE_POINTS, {
      params: { username, title },
      wrapInModal: false,
    })
);
